'use strict';
module.exports = '1.7.0';
